import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { IconRegistryService } from '@rd/core/services/icon-registry/icon-registry.service';
import { SortOption } from '@rd/types';
import { DialogConfig } from '../../dialog-config';
import { DialogRef } from '../../dialog-ref';

@Component({
  selector: 'rd-popup-sort-dialog',
  templateUrl: './sort-dialog.component.html',
  styleUrls: ['./sort-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PopupSortDialogComponent {
  @HostBinding('class.rd-popup-sort-dialog') componentClass = true;

  value: SortOption['value'];

  constructor(
    private dialogRef: DialogRef,
    private dialogConfig: DialogConfig<{
      value: SortOption['value'];
      onChange: (option: SortOption) => void;
      options: SortOption[];
    }>,
    private iconRegistryService: IconRegistryService,
  ) {
    if (this.dialogConfig.data) {
      this.value = this.dialogConfig.data.value;
    }
    this.registerIcons();
  }

  private registerIcons(): void {
    this.iconRegistryService.registerIcon('check');
  }

  getOptions(): SortOption[] {
    return this.dialogConfig.data?.options ?? [];
  }

  closeModal(): void {
    this.dialogRef.close({ closeOnSubmit: true });
  }

  isSelected(value: SortOption['value']): boolean {
    return value === this.value;
  }

  onChange(option: SortOption): void {
    this.dialogConfig.data?.onChange(option);
    this.value = option.value;
    setTimeout(() => {
      // add delay to let user know that the clicked sort option have been selected
      this.closeModal();
    }, 300);
  }
}
